import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export default function PageMeta({ pageKey }) {
  const { t, i18n } = useTranslation();
  const title = t(`page_meta.${pageKey}.title`);
  const description = t(`page_meta.${pageKey}.description`);
  const ogImage = `${window.location.origin}/og-image.png`;

  return (
    <Helmet>
      <html lang={i18n.language} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
